import {
  config as AWSConfig,
  CognitoIdentityCredentials,
  Lambda,
  CognitoIdentityServiceProvider
} from 'aws-sdk';
import config from '../config';

const AWSRegion = config.cognito.region;

AWSConfig.region = AWSRegion;

export { AWSRegion, AWSConfig, CognitoIdentityCredentials, Lambda, CognitoIdentityServiceProvider };


// WEBPACK FOOTER //
// ./src/lib/awsSDK.js